import React from 'react';

import Modal from '@fmbt/ui/Modal';
import Text from '@fmbt/ui/Text';
import DefaultButton from 'components/atoms/DefaultButton';
import WarningModal from 'components/modals/WarningModal';
import { ROUTE_PATHS } from 'constants/routePaths';
import { useCiboCancellationModal, useCiboPlacedZonesModal } from 'store/modules/backOfficeCiboSubscriptions/hooks';

interface CancelSubscriptionButtonProps {
  disabled?: boolean;
  enterpriseDomain: string;
  dateAdded: string;
  subscriptionId: number;
  onCancel: (subscriptionId: number) => void;
  isCancelling: boolean;
}

function CancelSubscriptionButton({
  disabled,
  enterpriseDomain,
  dateAdded,
  subscriptionId,
  onCancel,
  isCancelling
}: CancelSubscriptionButtonProps) {
  const {
    isOpen: isConfirmModalOpen,
    openModal: openConfirmModal,
    closeModal: closeConfirmModal
  } = useCiboCancellationModal(subscriptionId);
  const {
    isOpen: isRecheckModalOpen,
    closeModal: closeRecheckModal,
    numberOfLocationsToRemove
  } = useCiboPlacedZonesModal(subscriptionId);

  return (
    <>
      <DefaultButton onClick={openConfirmModal} disabled={disabled}>
        Cancel subscription
      </DefaultButton>
      <Modal
        confirmHref={`${enterpriseDomain}${ROUTE_PATHS.enterprise.samplePoints.mapView}`}
        confirmText="Go to Enterprise"
        dismissText="Go Back"
        isOpen={isRecheckModalOpen}
        // The user is checking the placed pasture zones in another tab anyway, so we can just close the modal
        onConfirm={closeRecheckModal}
        onDismiss={closeRecheckModal}
        size={360}
        title="Check Placed Pasture Zones"
      >
        <Text v="body">
          Before cancelling, please remove{' '}
          <Text v="body-emphasis" inline>{numberOfLocationsToRemove}</Text>{' '}
          Pasture Zone(s) from the map to match the remaining Total Purchased (the amount after cancelling).
          <br />Please update billing to reflect new amount.
        </Text>
      </Modal>
      <WarningModal
        title="Cancel Subscription?"
        isOpen={isConfirmModalOpen}
        dismissText="Go Back"
        onDismiss={closeConfirmModal}
        confirmText="Cancel Subscription"
        onConfirm={() => onCancel(subscriptionId)}
        isConfirmButtonLoading={isCancelling}
        size={360}
      >
        <Text v="body">
          Are you sure you want to cancel this item<br /> that was added on {dateAdded}?
          <br />This action cannot be undone.
        </Text>
      </WarningModal>
    </>
  );
}

export default CancelSubscriptionButton;